import { DecisionContext, ProjectStatus } from "@/dbot/common/commonDomain";
import { makeAutoObservable } from "mobx";
import { DecisionType } from "@/common/decisions";
import { PreviousAccountant } from "@/dbot/accountant/accountantDomain";

export type NoAccountant = {
  type: DecisionType.noAccountant;
  previousAccountant: PreviousAccountant;
};

export class NoAccountantForm {
  readonly type = DecisionType.noAccountant;
  readonly context: DecisionContext<NoAccountant>;
  readonly data?: NoAccountant;

  constructor(context: DecisionContext<NoAccountant>, data?: NoAccountant) {
    makeAutoObservable(this, { type: false, data: false }, { autoBind: true });
    this.context = context;
    this.data = data;
  }

  get accountantOrganizationnumber() {
    return this.context.initialState?.company?.accountantOrganizationnumber ?? "";
  }

  get hasAccountant(): boolean {
    return (
      this.context.projectStatus !== ProjectStatus.DRAFT ||
      this.accountantOrganizationnumber.trim() !== ""
    );
  }

  get previousAccountant(): PreviousAccountant | undefined {
    const current = this.context.contextData[this.context.orgNo]?.initialState?.currentAccountant;
    if (!current) return undefined;
    return {
      name: current.name,
      organisationNumber: current.organisationNumber,
      businessAddress1: current.businessAddress1,
      businessAddress2: current.businessAddress2,
      businessZip: current.businessZip,
      businessCity: current.businessCity,
      businessCountry: current.businessCountry,
    };
  }

  get isProjectLocked(): boolean {
    return this.context.isLocked;
  }
}
